{
  "status": {
    "overdue": "EN RETARD"
  },
  "actions": {
    "create_task": "Créer une tâche",
    "update_task": "Modifier la tâche",
    "save_task": "Enregistrer la tâche",
    "cancel_create_task": "Annuler la création de tâche"
  },
  "form": {
    "labels": {
      "due_date": "Date d'échéance",
      "assigned_to": "Assigné à",
      "requested_by": "Demandé par",
      "description": "Description"
    },
    "placeholders": {
      "assigned_to": "assigné à",
      "requested_by": "demandé par"
    },
    "validation": {
      "task_required": "Veuillez saisir une tâche",
      "date_too_old": "c'est trop ancien",
      "date_too_far": "c'est trop loin",
      "task_name_empty": "Le nom de la tâche ne peut pas être vide",
      "unexpected_error": "Une erreur inattendue s'est produite lors de l'ajout de la tâche."
    }
  },
  "table": {
    "headers": {
      "tasks": "Tâches",
      "priority": "Priorité",
      "due_date": "Date d'échéance",
      "assigned_to": "Assigné à",
      "source": "Source"
    }
  },
  "delete": {
    "confirmation_message": "Cliquez sur confirmer pour supprimer la tâche"
  },
  "aria_labels": {
    "create_new_task": "créer une nouvelle tâche"
  },
  "slide": {
    "labels": {
      "due_date": "Date d'échéance",
      "source": "Source",
      "assigned_to": "Assigné à",
      "requested_by": "Demandé par",
      "completed_by": "Terminé par",
      "description": "Description",
      "comments": "Commentaires"
    }
  },
  "sections": {
    "completed": "Terminé"
  },
  "empty_state": {
    "title": "Aucune tâche pour le moment",
    "description": "Commencez par créer une tâche et organiser votre travail"
  },
  "display": {
    "empty_value": "-"
  },
  "partials_form": {
    "labels": {
      "associated_company": "Entreprise associée",
      "contact": "Contact",
      "task": "Tâche",
      "due_date": "Date d'échéance",
      "assign_to": "Assigner à"
    },
    "placeholders": {
      "associated_company": "Entreprise associée",
      "contact": "Contact",
      "describe_task": "Décrivez la tâche"
    },
    "validation": {
      "company_required": "veuillez saisir une entreprise",
      "task_required": "Veuillez saisir une tâche",
      "date_too_old": "c'est trop ancien",
      "date_too_far": "c'est trop loin"
    },
    "buttons": {
      "add_task": "+ Tâche"
    },
    "modal": {
      "create_title": "Créer une tâche",
      "update_title": "Modifier la tâche"
    }
  }
}
